<template>
  <VTextField :type="type" variant="outlined" color="primary" density="comfortable" :bg-color="$vuetify.theme.current.colors.surface" v-bind="$attrs">
    <template v-for="(x, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </VTextField>
</template>

<script setup>
defineProps({
  type: { type: String, required: false, default: 'text' },
});
</script>
